const Door = props => (
  <svg {...props} width="15px" height="15px" viewBox="0 0 15 15">
    <g id="FPCBuilder" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" transform="translate(-490.000000, -95.000000)">
      <path d="M490.5,96.5 L504.5,96.5 C504.5,96.5 504.5,109.5 490.5,109.5" id="Door" stroke="#FFFFFF" strokeWidth="1.5" transform="translate(497.500000, 103.000000) rotate(-90.000000) translate(-497.500000, -103.000000) "></path>
    </g>
  </svg>
);

export default Door;
